import * as types from "../../constants";

// Only the light theme is enabled. The theme toggle is not rendered anywhere,
// so a stale "theme" value left in localStorage (from when dark mode could be
// selected) would otherwise lock a browser into the dark theme with no way back.
const initialState = {
  currentTheme: types.THEMES.LIGHT,
};

export default function reducer(state = initialState, actions) {
  switch (actions.type) {
    case types.THEME_SELECTED:
      return {
        ...state,
        currentTheme: actions.payload,
      };

    default:
      return state;
  }
}
